import React, { useEffect, useState } from 'react';

import { BreadCrumbTrail } from '../../common/breadcrumb-trail/BreadcrumbTrail';
import { BackButton } from '../../common/button/back-button/BackButton';
import { ClientsCreateGeneralTab } from './general/ClientsCreateGeneralTab';
import { ClientsCreateConsentTab } from './consent/ClientsCreateConsentTab';

import './ClientsCreate.css';

export const ClientsCreate = ({
  context,
  setContext,
  navigateTo,
  navigateToWith,
  showToaster,
  setSpinnerText,
  toolTipsEnabled,
  navigateBack,
}) => {
  useEffect(() => {
    if (context.breadcrumbs.newClientGeneralBreadcrumb) {
      if (context.breadcrumbs.newClientGeneralBreadcrumb.data !== {}) {
        setClient(context.breadcrumbs.newClientGeneralBreadcrumb.data);
      } else {
        setClient({});
      }
    }
    if (context.breadcrumbs.newClientConsentBreadcrumb) {
      if (context.breadcrumbs.newClientConsentBreadcrumb.data !== {}) {
        setConsent(context.breadcrumbs.newClientConsentBreadcrumb.data);
      } else {
        setConsent({});
      }
    }
  }, [context.breadcrumbs.newClientConsentBreadcrumb, context.breadcrumbs.newClientGeneralBreadcrumb]);

  const [buttonPressed, setButtonPressed] = useState(false);
  const [showConsentTab, setShowConsentTab] = useState(false);
  const [activeTab, setActiveTab] = useState('clientsCreateGeneral');
  const [client, setClient] = useState({});
  const [consent, setConsent] = useState({});
  const [currentScreen, setCurrentScreen] = useState('clientsCreateGeneral');

  const handleSaveClick = (link) => {
    setButtonPressed(true);
    setCurrentScreen(link);
  };

  const screenMap = new Map();
  screenMap.set(
    'clientsCreateGeneral',
    <ClientsCreateGeneralTab
      context={context}
      setContext={setContext}
      client={client}
      setClient={setClient}
      setCurrentScreen={setCurrentScreen}
      toolTipsEnabled={toolTipsEnabled}
      setSpinnerText={setSpinnerText}
      handleSaveClick={handleSaveClick}
      setShowConsentTab={setShowConsentTab}
      showToaster={showToaster}
      editMode={false}
    />
  );
  screenMap.set(
    'clientsCreateConsent',
    <ClientsCreateConsentTab
      context={context}
      consent={consent}
      setConsent={setConsent}
      setContext={setContext}
      navigateTo={navigateTo}
      navigateToWith={navigateToWith}
      setActiveTab={setActiveTab}
      toolTipsEnabled={toolTipsEnabled}
      setSpinnerText={setSpinnerText}
      showToaster={showToaster}
    />
  );

  const handleBack = () => {
    navigateBack();
  };

  const handleNavigationClick = (tab) => {
    setActiveTab(tab);
    setCurrentScreen(tab);
  };

  return (
    <div className="clients-create-container">
      <div className="clients-create-header-container">
        <BackButton onClick={handleBack} />
        <h2>Create New Client</h2>
      </div>

      <div className="wizard-content-container">
        <div className="wizard-main-content-container">
          <div className="clients-create-container">
            <div className="clients-create-tab-container">
              <div
                className={'clients-create-tab general ' + (activeTab === 'clientsCreateGeneral' ? 'active-tab' : null)}
                onClick={() => handleNavigationClick('clientsCreateGeneral')}
              >
                General
              </div>
              {showConsentTab && (
                <div
                  className={
                    'clients-create-tab consent ' + (activeTab === 'clientsCreateConsent' ? 'active-tab' : null)
                  }
                  onClick={() => handleNavigationClick('clientsCreateConsent')}
                >
                  Consent
                </div>
              )}
            </div>
            <div className={'clients-create-tab-content ' + activeTab}>
              {buttonPressed ? screenMap.get(currentScreen) : screenMap.get('clientsCreateGeneral')}
            </div>
          </div>
        </div>

        <div className="wizard-breadcrumb-container">
          <BreadCrumbTrail context={context} navigateTo={navigateTo} />
        </div>
      </div>
    </div>
  );
};
